module.exports = __webpack_public_path__ + "img/5.1.1b8f6d7e.png";